import React from 'react';
import { Printer, Scissors, Gift, Palette } from 'lucide-react';
const services = [{
  title: 'Custom Screen Printing',
  description: 'Professional screen printing for t-shirts, team uniforms, spirit wear, and event apparel. Ideal for schools, sports teams, clubs, and community organizations.',
  icon: Printer
}, {
  title: 'Embroidery',
  description: 'Durable, professional embroidery for logos, names, and designs on polos, hats, jackets, and business apparel.',
  icon: Scissors
}, {
  title: 'Personalized Gifts & Accessories',
  description: 'Custom gifts including drinkware, decals, keychains, bows, headbands, and more—perfect for teachers, teams, events, and special occasions.',
  icon: Gift
}, {
  title: 'Sublimation & Custom Decals',
  description: 'Vibrant full-color designs using sublimation printing and custom vinyl decals for apparel and accessories.',
  icon: Palette
}];
export function ServicesSection() {
  return <section id="services" className="py-20 bg-white" data-id="element-222">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-223">
        {/* Header Section */}
        <div className="text-center mb-16" data-id="element-224">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6 leading-tight" data-id="element-225">
            Custom Apparel & Personalized Products in Leonardtown, Maryland
          </h2>
          <p className="text-lg text-gray-600 max-w-4xl mx-auto leading-relaxed" data-id="element-226">
            Teams ‘n Tees specializes in high-quality custom apparel and
            personalized products for schools, teams, businesses, and families
            in Leonardtown and throughout Southern Maryland. From custom
            t-shirts to embroidered apparel and unique gifts, every order is
            crafted with care and attention to detail.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-227">
          {services.map((service, index) => <div key={index} className="group h-full bg-white rounded-2xl p-8 border border-gray-100 shadow-sm hover:shadow-lg hover:border-purple-200 transition-all duration-300 flex flex-col" data-id="element-228">
              <div className="mb-6 inline-flex items-center justify-center h-14 w-14 rounded-xl bg-purple-50 text-purple-600 group-hover:bg-purple-600 group-hover:text-white transition-colors duration-300" data-id="element-229">
                <service.icon className="h-7 w-7" aria-hidden="true" data-id="element-230" />
              </div>

              <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-purple-700 transition-colors" data-id="element-231">
                {service.title}
              </h3>

              <p className="text-gray-600 leading-relaxed flex-grow" data-id="element-232">
                {service.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}